module.exports = __webpack_public_path__ + "3abc5d7b05d5dd5c7f8437ac1c09ae34.pdf";